module.exports = __webpack_public_path__ + "img/kypc.7e187149.png";